import { parseAsString, useQueryState } from "nuqs";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener.ts";

const useKeyboardShortcutOpenShortcutInfoModal = () => {
  const [currentModal, setCurrentModal] = useQueryState(
    URLSearchParamKeys.MODAL,
    parseAsString
      .withDefault('')
      .withOptions({
        history: 'push',
        shallow: true,
        clearOnDefault: true,
      }),
  );

  useKeyboardListener((event) => {
    if (event.shiftKey && event.key === 'F1') {
      event.preventDefault();
      if (currentModal !== '' && currentModal !== URLSearchParamKeys.KEYBOARD_SHORTCUT_INFO_MODAL) {
        setCurrentModal(URLSearchParamKeys.KEYBOARD_SHORTCUT_INFO_MODAL);
        return;
      }

      setCurrentModal(
        !currentModal
          ? URLSearchParamKeys.KEYBOARD_SHORTCUT_INFO_MODAL
          : ''
      );
    }
  });
};

export default useKeyboardShortcutOpenShortcutInfoModal;
